module.exports = __webpack_public_path__ + "img/feature.38364937.png";